import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

import {
  formatDate,
  formatDateTime,
  formatDateToISOWeek,
} from '../util/date-util'

interface Props {
  date: string
  endDate?: string
  type?: string
  showTime?: boolean
  wachtTijdDatum?: string
  showWeek?: boolean
}

const format = (date: string, showTime?: boolean) =>
  date && (showTime ? formatDateTime(date) : formatDate(date))

const TYPE_WENSDATUM_KLANT = 'Wensdatum klant'

export default function Realisatie({
  date,
  endDate,
  type,
  showTime,
  wachtTijdDatum,
  showWeek = false,
}: Props) {
  if (!date) return <></>

  let planType = (type && type.trim()) || 'Onbekend'

  if (planType === TYPE_WENSDATUM_KLANT && wachtTijdDatum) {
    planType = `${planType} rekening houdend met een minimale wachttijd datum van ${format(
      wachtTijdDatum,
    )} `
  }

  let label = format(date, showTime)

  if (endDate) {
    label = `${label} · ${format(endDate, showTime)}`
  }

  if (showWeek) {
    const week = formatDateToISOWeek(date).split('-')[1]
    label = `${label} - (${week})`
  }

  return (
    <Chip
      variant="outlined"
      avatar={
        <Tooltip title={planType} placement="bottom-start">
          <Avatar
            sx={{
              color: 'black !important',
              cursor: 'default',
              backgroundColor: '#eeeeee',
            }}
          >
            {planType[0]}
          </Avatar>
        </Tooltip>
      }
      label={label}
    />
  )
}
